import axios from "axios";
import * as yup from "yup";
import { INotes, noteSchema } from "./Notes";
import { contactSchema, IContact } from "./Contacts";
import { addressSchema, IAddress } from "./Address";

export interface IClientFilter {
  search: string;
  sectors: number[];
  address: IAddress | null;
}

export interface IClient {
  id?: number;
  name: string;
  address: IAddress | null;
  logo?: string;
  folder?: string;
  sectors: number[];
  contacts: IContact[];
  notes: INotes[];
}

export const clientSchema: yup.SchemaOf<IClient> = yup.object({
  id: yup.number().optional(),
  name: yup.string().required("Name is a required field."),
  logo: yup.string().optional(),
  folder: yup.string().optional(),
  sectors: yup.array().of(yup.number().integer().required()).min(1),
  notes: yup.array().of(noteSchema).optional(),
  contacts: yup.array().of(contactSchema).optional(),
  address: addressSchema.nullable().optional(),
});

export interface IClientListItem {
  id: number;
  name: string;
  logo: string;
  folder: string;
  sectors: string[];
}

export interface IClientList {
  count: number;
  next: string | null;
  previous: string | null;
  results: IClientListItem[];
}

export const fetchClients = async (query: string): Promise<IClientList> => {
  const response = await axios.get<IClientList>(`/clients/?${query}`);
  return response.data;
};

export const fetchClient = async (id: string): Promise<IClient> => {
  const response = await axios.get<IClient>(`/clients/${id}/`);
  return response.data;
};
